import React from "react";
import { Card, Stack, ProgressBar } from "react-bootstrap";
import { currencyFormatter } from "../utils";
import { useBudgets } from "../contexts/BudgetContext";

export default function HistoryCard(props) {
  const { history, budgets } = useBudgets();
  const max = budgets.reduce((total, budget) => total + budget.max, 0);

  if (history.length === 0) return null;
  return (
    <Card className="bg-light">
      <Card.Body>
        <Card.Title className="align-items-baseline mb-3 fs-3">
          History
        </Card.Title>

        {history.map((historyx) => (
          <Stack direction="horizontal" gap="2" key={historyx.id}>
            <div className="p-2 fs-5">
              {currencyFormatter.format(historyx.amount)} /{" "}
              {currencyFormatter.format(max)}
            </div>
            <div className="p-2 w-50 fs-5">
              <ProgressBar
                className="rounded-pill"
                height="50px"
                variant={getProgressBarVariant(historyx.amount, historyx.max)}
                min={0}
                max={max}
                now={historyx.amount}
                label={`${historyx.amount} / ${max}`}
              />
              <div className="p-2 fs-5">
                <ProgressBar
                  className="rounded-pill"
                  height="50px"
                  variant="warning"
                  min={0}
                  max={historyx.expenseCount}
                  now={historyx.aligned}
                  label={`${historyx.aligned} / ${historyx.expenseCount}`}
                />
              </div>
            </div>

            <div className="p-2 ms-auto fs-5"> {historyx.date}</div>
          </Stack>
        ))}
      </Card.Body>
    </Card>
  );
}
function getProgressBarVariant(amount, max) {
  const ratio = amount / max;
  if (ratio < 0.5) return "primary";
  if (ratio < 0.75) return "warning";
  return "danger";
}
